import { useGridApiRef } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import React, { useState } from 'react';
import { useProductsUsageReport } from '../../../../hooks/requests/use-products-usage-report';
import { ReportHeader } from '../../reports-components/ReportHeader';
import { ReportTable } from '../../reports-components/ReportTable';
import { REPORT_TYPES } from '../../reports-page/reports-page-types/report-type';
import { ProductsUsageReportTable } from './products-usage-report-table/ProductsUsageReportTable';

type ProductUsageReportContentProps = {
  reportId: string;
};

export const ProductUsageReportContent: React.FC<ProductUsageReportContentProps> = ({ reportId }) => {
  const { data: productReportData, isLoading } = useProductsUsageReport(reportId);
  const [searchText, setSearchText] = useState<string>();
  const apiRef = useGridApiRef();
  const { report, startDate, endDate, creationDate } = productReportData;

  return (
    <>
      <ReportHeader reportData={report} startDate={startDate} endDate={endDate} creationDate={creationDate} />
      <ReportTable
        title="Product Usage Report"
        placeholder="Enter customer name..."
        exportCsvFileName="Product usage report"
        reportType={REPORT_TYPES.PRODUCTS_USAGE}
        reportCreationDate={creationDate}
        onSearch={(searchValue) => setSearchText(searchValue)}
        apiRef={apiRef as React.MutableRefObject<GridApiCommunity>}
      >
        <ProductsUsageReportTable
          isLoading={isLoading}
          filter={searchText ?? undefined}
          apiRef={apiRef as React.MutableRefObject<GridApiPro>}
          rows={report}
        />
      </ReportTable>
    </>
  );
};
